import { motion, useReducedMotion } from 'motion/react';

export function LandingBackdrop() {
  const reduce = useReducedMotion();

  return (
    <div className="landing-field" aria-hidden="true">
      {reduce ? (
        <div className="field-orb static" />
      ) : (
        <>
          <motion.div
            className="field-orb a"
            animate={{ x: [0, 68, -20, 0], y: [0, -44, 30, 0], scale: [1, 1.12, 0.95, 1] }}
            transition={{ duration: 26, repeat: Infinity, ease: 'easeInOut' }}
          />
          <motion.div
            className="field-orb b"
            animate={{ x: [0, -52, 28, 0], y: [0, 38, -26, 0], scale: [1, 0.9, 1.1, 1] }}
            transition={{ duration: 32, repeat: Infinity, ease: 'easeInOut' }}
          />
          <motion.div
            className="field-orb c"
            animate={{ x: [0, 22, -30, 0], y: [0, 28, -18, 0], opacity: [0.35, 0.7, 0.45, 0.35] }}
            transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
          />
        </>
      )}
      <div className="field-grid grid-bg" />
      <div className="field-scan" />
      <div className="field-grain grain" />
    </div>
  );
}
